import TaskCreate from "../components/TaskCreate";

export default function TaskCreatePage() {
  return <TaskCreate />;
}
